/**
 * Feature detection for modern JavaScript features required by pdfjs-dist.
 * 
 * iOS Safari 16.3.1 and older cannot parse:
 * - Private class fields (#field)
 * - Static initialization blocks (static { ... })
 * 
 * This utility checks if the browser can parse these features before
 * attempting to load pdfjs-dist, preventing SyntaxError crashes.
 */

/**
 * Checks if the browser can parse private class fields.
 * Uses a try-catch with Function constructor to test parsing without execution.
 */
function canParsePrivateFields(): boolean {
  try {
    // Test private class field syntax
    new Function('class Test { #field = 1; }');
    return true;
  } catch {
    return false;
  }
}

/**
 * Checks if the browser can parse static initialization blocks.
 * Uses a try-catch with Function constructor to test parsing without execution.
 */
function canParseStaticInitBlocks(): boolean {
  try {
    // Test static initialization block syntax
    new Function('class Test { static { } }');
    return true;
  } catch {
    return false;
  }
}

/**
 * Checks if the current browser supports the modern JavaScript features
 * required by pdfjs-dist. Returns true if the browser can safely load pdfjs-dist,
 * false if it should use a fallback UI instead.
 */
export function canLoadPDFJS(): boolean {
  return canParsePrivateFields() && canParseStaticInitBlocks();
}

